import { axiosInstance } from './api'

import { GETSettings } from 'types/settings'

export const settingsApi = {
  get() {
    return axiosInstance.get<GETSettings>('settings')
  },
  update(params: FormData) {
    return axiosInstance.put('settings', params)
  },
  checkSubscription() {
    return axiosInstance.head('settings')
  },
  getSubscriptionHistory() {
    return axiosInstance.get('settings/subs-history')
  },
  postAPIToken() {
    return axiosInstance.post('settings/api-token')
  },
  getAPIToken() {
    return axiosInstance.get('settings/api-token')
  },
}
